
import {
    NotificationService,
    NotificationType,
    Notification,
} from './notifications';
import { defineComponent } from 'vue';

interface NotificationDisplay {
    id: number;
    message: string;
    nClass: Array<string>;
}

export default defineComponent({
    created(): void {
        const service = NotificationService.getInstance();
        this.renderNotifications();
        service.onChange.on(() => {
            this.renderNotifications();
        });
    },

    data() {
        return {
            notifications: [] as Array<NotificationDisplay>,
        };
    },

    methods: {
        notificationClass(ty: NotificationType): string {
            switch (ty) {
                case NotificationType.Success:
                    return 'notification-success';
                case NotificationType.Error:
                    return 'notification-error';
                default:
                    return 'notification-default';
            }
        },

        removeNotification(id: number): void {
            NotificationService.getInstance().removeNotification(id);
        },

        renderNotifications(): void {
            this.notifications = NotificationService.getInstance()
                .getNotifications()
                .map((n: Notification) => {
                    return {
                        id: n.id,
                        message: n.message,
                        nClass: [
                            'notification',
                            this.notificationClass(n.type),
                        ],
                    };
                });
        },
    },
});
